import React from "react";
import {
    Box,
    Container,
} from "@mui/material";

import Banner from "../components/Banner";
import BenefitsRow from "../components/BenefitsRow";
import TopSellersCarousel from "../components/TopSellersCarousel";
import SobreHome from "../components/SobreHome";
import WholesaleWhatsAppBanner from "../components/WholesaleWhatsAppBanner";

const Home = () => {
    return (

        <Box sx={{ backgroundColor: "var(--backgroundPage)", pb: 10 }}>
            <Banner />
            <Container maxWidth="lg" sx={{ px: { xs: 2, md: 3 }, mt: 3 }}>
                <WholesaleWhatsAppBanner />
            </Container>
            <BenefitsRow />
            <TopSellersCarousel />
            <SobreHome />
        </Box>
    );
};

export default Home;
